// src/App.jsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout Components (Static on all pages)
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Page Components (Ensure these files/folders exist in src/pages/)
import HomePage from './pages/HomePage/HomePage';
import AboutPage from './pages/AboutPage/AboutPage';
import ServicesPage from './pages/ServicesPage/ServicesPage';
import ProjectsPage from './pages/ProjectsPage/ProjectsPage';
import MaterialsPage from './pages/MaterialsPage/MaterialsPage';
import ContactPage from './pages/ContactPage/ContactPage';
import FloatingSocialIcons from './components/sections/FloatingSocialIcons/FloatingSocialIcons';

// Section Component imported as a page route
import OurWorks from './components/sections/OurWorks/OurWorks'; // FIXED: Pointing directly to your component path

// Component to wrap dynamic content with static Navbar and Footer
const Layout = ({ children }) => {
    return (
        // FIX: Added 'overflow-x-hidden' to the main layout wrapper
        <div className="min-h-screen bg-light overflow-x-hidden"> 
            <Navbar /> 
            
            <main>{children}</main>
            
            <Footer />
        </div>
    );
};

function App() {
    return (
        <Router>
            <Layout>
                <Routes>
                    {/* Home Route: The landing page */}
                    <Route path="/" element={<HomePage />} />
                    
                    {/* Dedicated Pages */}
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/projects" element={<ProjectsPage />} />
                    <Route path="/ourworks" element={<OurWorks />} /> {/* Route maps to your component */}
                    <Route path="/materials" element={<MaterialsPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    
                    {/* Fallback Route */}
                    <Route path="*" element={<HomePage />} />
                </Routes>
                {/* FIX: Moved FloatingSocialIcons outside <Routes> to make it visible on all pages */}
                <FloatingSocialIcons /> 
            </Layout>
        </Router>
    );
}

export default App;